import React from "react";
import {TimeTick} from './style'
const TimeBlock = ({startTime,endTime}) => {
  
  return (
    <TimeTick>
      <div className="title">比赛时间</div>
      <div className="content">{startTime} - {endTime} </div>
    </TimeTick>
  )
}

export default TimeBlock;


// WEBPACK FOOTER //
// ./src/views/activity_50/components/TimeBlock.js